<template>
  <SPAGlobalLoader v-if="useGlobalLoader.loading" />

  <router-view name="navbar"></router-view>
  <router-view name="sidebar"></router-view>
  <router-view></router-view>
</template>

<style lang="scss">
@use 'mdb-vue-ui-kit/src/scss/index.pro.scss' as *;
@use '@/assets/fonts/Rubik/Rubik.css' as *;
@use '@/assets/fonts/SproutIcon/style.css' as *;
@use 'floating-vue/dist/style.css' as *;

:root {
  --mdb-breadcrumb-divider: url('./assets/arrow-right.png');
}

#app {
  position: relative;
  height: 100vh;
  font-family: 'Rubik', Helvetica, Arial, sans-serif;
}

.v-popper--theme-default-tooltip {
  &#transaction-list-tooltip,
  &#readywage-transaction-info-tooltip {
    .v-popper__wrapper {
      .v-popper__inner {
        @apply tw-h-[24px] tw-flex tw-items-center tw-border-r-[8px] tw-overflow-hidden tw-font-Rubik;
        background-color: $neutral-900 !important;
        padding: 0 8px !important;

        div {
          @apply tw-text-[12px] tw-text-neutral-0;
        }
      }
    }
  }
}

.ps--active-x > .ps__rail-x,
.ps--active-y > .ps__rail-y {
  opacity: 1 !important;
  pointer-events: auto !important;
}
</style>

<script setup>
import { computed, watch, onMounted } from 'vue';
import { version } from '../package.json';

import * as signalR from '@microsoft/signalr';

import { getPendoData } from './helpers/pendo';

import { useClientStore } from './stores/client';
import { useRouteAccessStore } from './stores/routeAccess';
import { useUserInfoStore } from './stores/userInfo';
import { useGlobalLoaderStore } from './stores/globalLoader';
import { useWebSettingsStore } from './stores/webSettings';
import SPAGlobalLoader from './components/SPAGlobalLoader.vue';

const useClient = useClientStore();
const useUserInfo = useUserInfoStore();
const routeAccessStore = useRouteAccessStore();
const useGlobalLoader = useGlobalLoaderStore();
const useWebSettings = useWebSettingsStore();

routeAccessStore.$subscribe(() => {
  if (routeAccessStore.routeAccess.isAuthenticated) {
    getPendoData(useClient.client.id, useUserInfo.userInfo.dashboardType);

    useWebSettings.getWebSettings();

    if (!useClient.client.parentBaseUrl) {
      useClient.getClient();
    }

    if (!useUserInfo.userInfo.userName) {
      useUserInfo.getUser();
    }
  }
});

const appIds = computed(() => {
  return { clientId: useClient.client.id, userId: useUserInfo.userInfo.id };
});

watch(appIds, (newAppIds) => {
  if (newAppIds.clientId && newAppIds.userId) {
    const base64Ids = window.btoa(`${newAppIds.clientId}/${newAppIds.userId}`);

    const connection = new signalR.HubConnectionBuilder()
      .withUrl(useWebSettings.getSignalRUrl('SignalRUri'), {
        headers: {
          'x-application-user-id': base64Ids,
        },
        withCredentials: false,
      })
      .withAutomaticReconnect()
      .configureLogging(signalR.LogLevel.Error)
      .build();

    connection.onclose(function () {
      console.log('signalr disconnected');
    });

    connection.onreconnecting((err) =>
      console.log('signalr error reconnecting  ', err)
    );

    connection.start();
  }
});

onMounted(() => {
  console.info('HR-SPA version:', version);
});
</script>
